/**
 * Occasions browser — tab strip that swaps the tile grid below it.
 *
 * Markup comes from sections/occasions_tabs.liquid with the ARIA wiring already
 * in place; this only moves selection and keyboard focus.
 */
class OccasionsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length === 0) return;

    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener('keydown', this._onKeydown);
  }

  _onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab));
  };

  /** Left/Right move between tabs, Home/End jump to the ends — standard tablist keys. */
  _onKeydown = (event) => {
    const current = this.tabs.indexOf(event.target.closest('[role="tab"]'));
    if (current === -1) return;

    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
    if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  };

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

if (!window.customElements.get('occasions-tabs')) {
  window.customElements.define('occasions-tabs', OccasionsTabs);
}
